import React from 'react';

const GoogleAdsIcon: React.FC = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 9.2h3V19H5zM10.6 5h3v14h-3zm5.6 8h3v6h-3z" />
  </svg>
);

export default GoogleAdsIcon;